<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-08 11:41:45
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-21 10:33:26
-->
<template>
	<div class="page_order page page_goodsUp">
		<van-tabs v-model="active" swipe-threshold="2" @change="changeTab">
			<van-tab title="商品" :name="1"></van-tab>
			<van-tab title="定制" :name="2"></van-tab>
		</van-tabs>
		<div class="" v-if="active == 1">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getGoodsData">
				<div class="list">
					<div class="item" v-for="(goods,index) in goodsList" :key="index">
						<div class="item_right">
							<div :class="goods.is_blockchain ? 'item_right_l blockchain' : 'item_right_l'">
								<img :src="goods.good_thumb ? imageUrl+goods.good_thumb : $publicData.intangibleDefault" alt="" class="tu">
							</div>
							<div class="item_right_r">
								<div class="item_right_r_t">
									<div class="title slh_s">{{ goods.good_title }}</div>
									<div class="store">
										<span class="yishou">已售{{ goods.sales }}</span>
										<span class="kucun">库存{{ goods.store }}</span>
									</div>
								</div>
								<div class="item_right_r_b">
									<div class="price">
										<span class="tag_cash">¥</span>
										<span class="">{{ goods.good_price }}</span>
									</div>
									<div class="actions">
										<div :class="goods.is_cloud == 1 ? 'action cancle-action' : 'action'" @click="pushGoodsFun(goods,index)">{{ goods.is_cloud == 1 ? '取消推送' : '推送' }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-list>
		</div>
		<div class="" v-if="active == 2">
			<van-list v-model="madeLoading" :finished="madeFinished" finished-text="没有更多了" @load="getMadeData">
				<div class="list">
					<div class="item" v-for="(item,index) in madeList" :key="index">
						<div class="item_right">
							<div class="item_right_l">
								<img :src="item.thumb ? imageUrl+item.thumb : $publicData.intangibleDefault" alt="" class="tu">
							</div>
							<div class="item_right_r">
								<div class="item_right_r_t">
									<div class="title slh_s">{{ item.title }}</div>
									<div class="jinjia">截止日期：{{ item.end_at }}</div>
								</div>
								<div class="item_right_r_b">
									<div class="price">
										<span class="tag_cash">¥</span>
										<span class="">{{ item.price_range}}</span>
										<span class="tag_cash">/个</span>
									</div>
									<div class="actions">
										<div :class="item.is_cloud == 2 ? 'action cancle-action' : 'action'" @click="pushMadesFun(item,index)">{{ item.is_cloud == 2 ? '取消推送' : '推送' }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-list>
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			active: 1,
			trad_uuid: null,
			page: 1,
			size: 10,
			goodsList: [],
			loading: false,
			finished: false,
			madeList: [],
			madeLoading: false,
			madeFinished: false,
			imageUrl: this.$publicData.uploadImage
		}
	},
	created() {
		this.token = this.$store.getters.token;
		this.trad_uuid = this.$route.query.trad_uuid;
	},
	methods: {
		/**
		 * @name: 推送或取消推送 定制
		 * @param {*} item
		 * @param {*} index
		 * @return {*}
		 * @desc: 
		 */		
		pushMadesFun(item,index){
			let is_cloud = item.is_cloud;
			let params = {
				token: this.token,
				custommade_id: [item.id],
				is_cloud: is_cloud == 2 ? 1 : 2
			};
			this.$api.tradesman.pushMades(params).then(res=>{
				if(res.code == 200){
					this.$toast(res.message);
					item.is_cloud = is_cloud == 2 ? 1 : 2;
					this.$set(this.madeList,index,item);
				}else{
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 切换商品、定制
		 * @return {*}
		 * @desc: 
		 */		
		changeTab(){
			this.page = 1;
			if(this.active == 1){
				this.goodsList = [];
				this.loading = true;
				this.finished = false;
				this.getGoodsData();
			}else{
				this.madeList = [];
				this.madeLoading = true;
				this.madeFinished = false;
				this.getMadeData();
			};
		},
		/**
		 * @name: 推送或取消推送商品
		 * @param {*} item
		 * @return {*}
		 * @desc: 
		 */		
		pushGoodsFun(item,index){
			let is_cloud = item.is_cloud;
			let params = {
				token: this.token,
				good_id: [item.good_id],
				is_cloud: is_cloud == 1 ? 0 : 1
			};
			this.$api.tradesman.pushGoods(params).then(res=>{
				if(res.code == 200){
					this.$toast(res.message);
					item.is_cloud = is_cloud == 1 ? 0 : 1;
					this.$set(this.goodsList,index,item);
				}else{
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 商家的商品列表
		 * @return {*}
		 * @desc: 
		 */		
		getGoodsData(){
			let params = {
				token: this.token,
				trad_uuid: this.trad_uuid,
				type: 1, // 在售
				page: this.page,
				size: this.size
			};
			this.$api.agent.tradGoods(params).then(res=>{
				if(res.code == 200){
					let list = res.result.good;
					if(list && list.length){
						for(let i in list){
							this.goodsList.push(list[i]);
						};
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						};
					}else{
						this.finished = true;
					}
				}else{
					this.finished = true;
				}
			})
		},
		/**
		 * @name: 商家的 定制列表
		 * @return {*}
		 * @desc: 
		 */		
		getMadeData(){
			let params = {
				token: this.token,
				trad_uuid: this.trad_uuid,
				page: this.page,
				size: this.size
			};
			this.$api.agent.tradMades(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list && list.length){
						for(let i in list){
							this.madeList.push(list[i]);
						};
						if(list.length < this.size){
							this.madeFinished = true;
						}else{
							this.page++;
							this.madeLoading = false;
						}
					}else{
						this.madeFinished = true;
					}
				}else{
					this.madeFinished = true;
				}
			})
		}
	},
}
</script>
<style scoped>
	.page_goodsUp .item .actions .action{
		width: auto;
		height: 0.6rem;
		line-height: 0.6rem;
		padding: 0 .2rem;
		border-radius: .4rem;
	}
	.page_goodsUp .item .actions .action.cancle-action{
		background: rgba(244, 244, 244, 1);
		color: rgba(0, 0, 0, 0.54);
		border: 0.0134rem solid rgba(0, 0, 0, 0.54);
	}
	.page_goodsUp .item .item_right{
		flex: 1;
	}
	.page_goodsUp .item .item_right_r{
		flex: 1;
	}
	.page_order .item_b{
		padding-top: 0;
	}
	.page_goodsUp .item_right_l .tu{
		object-fit: cover;
		width: 2.47rem;
		height: 2.47rem;
	}
</style>